import SlsPedidosClient from '@/api/Operacoes/sls-pedidos.client';
import Store from '@/store';
import Notifier from '@/libs/Notifier';

export default class SLSPedidosService {
  constructor() {
    this.client = new SlsPedidosClient();
    this.store = Store;
    this.notify = new Notifier();
  }

  async finalizarPedidoCart(data = this.store.getters['PedidosStore/getPedido']) {
    try {
      return await this.client.postPedidosSalvarPedidoCarrinho(data);
    } catch (error) {
      throw error;
    }
  }

  async finalizarRascunhoCart(data = this.store.getters['PedidosStore/getPedido']) {
    try {
      return await this.client.postPedidosSalvarRascunhoCarrinho(data);
    } catch (error) {
      throw error;
    }
  }

  async finalizarPedidoOperacao(data) {
    try {
      return await this.client.createPedidoOperacao(data);
    } catch (error) {
      throw error;
    }
  }

  async finalizarRascunhoOperacao(data) {
    try {
      return await this.client.createRascunhoOperacao(data);
    } catch (error) {
      throw error;
    }
  }

  async deletePedido(pedidoId) {
    try {
      return await this.client.deletePedidosById(pedidoId);
    } catch (error) {
      this.notify.error(error);
      throw error;
    }
  }

  async atualizarDadosPedido(pedidoId, data) {
    try {
      return await this.client.updatePedidoHeader(pedidoId, data);
    } catch (error) {
      this.notify.error(error);
      throw error;
    }
  }
}
